import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Footer from "examples/Footer";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Avatar,
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Drawer,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    TextField,
    TextareaAutosize,
    Tooltip,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import dayjs from "dayjs";
import InfoIcon from "@mui/icons-material/Info";
import AddIcon from "@mui/icons-material/Add";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { Edit, Delete, PendingActions, Close, Event, CalendarViewDay, AccessTime, DateRange, ExpandMore, ArrowDropDown, Cancel, Approval } from "@mui/icons-material";
import MDTypography from "components/MDTypography";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ApiCalls from "services/flick_erp_api_call";
import moment from "moment";
import MDButton from "components/MDButton";
import colors from "assets/theme/base/colors";
import { base_url } from "services";

function ManageLeaves(props) {
    const user = JSON.parse(localStorage.getItem("user"));

    const [approvalDialog, setApprovalDialog] = useState(false);
    const [leavePayload, setLeavePayload] = useState({});
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [remark, setRemark] = useState("");
    const [showTLUpdateCard, setShowTLUpdateCard] = useState(false);
    const [showHRUpdateCard, setShowHRUpdateCard] = useState(false);
    const [leaveBalance, setLeaveBalance] = useState(null);
    const [description, setDescription] = useState("")

    const toggleTLUpdateCard = () => setShowTLUpdateCard(!showTLUpdateCard);
    const toggleHRUpdateCard = () => setShowHRUpdateCard(!showHRUpdateCard);


    // const [employee, setEmployee] = useState({});

    useEffect(() => {
        getLeaveApproval();
    }, []);




    async function getLeaveApproval() {
        const status = props.action.label === 'Approved'
            ? 'approved'
            : props.action.label === 'Rejected'
            ? 'rejected'
            : 'pending';
    
        const res = await ApiCalls.getLeaveApproval(`?leave__status=${status}`);
        if (res.success && res.code == 200) {
            let filteredData = res.data;
    
            filteredData.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    
            setLeaveData((prev) => ({ ...prev, rows: filteredData }));
        }
    }

    async function getLeaveBalance(id) {
        var res = await ApiCalls.getEmployeeLeaveBalance(id);
        if (res.success && res.code == 200) {
          setLeaveBalance(res.data)
        }
      }

    async function handleDeleteLeave(row) {
        var res = await ApiCalls.deleteLeaveRequest(row?.leave?.id);
        if (res.success && res.code == 204) {
            getLeaveApproval();
        }
    }

    // approve Leave
    async function approveLeave(id, status, managerId, tlId) {
        let tl_data = {
            tl_decision: status,
            tl_reason: description,
        };
        let manager_data = {
            manager_decision: status,
            manager_reason: description,
        };
        if (managerId == tlId) {

            let res = await ApiCalls.updateLeaveApprovalAsManager(
                id,
                manager_data,
                false
            );
            if (res.success) {
                handleCloseDrawer();
             }
        }
        else if (user.employee_id == managerId) {

            let res = await ApiCalls.updateLeaveApprovalAsManager(
                id,
                manager_data,
                false
            );
            if (res.success) {
               handleCloseDrawer();
            }
        }
        else if (user.employee_id == tlId) {

            let res = await ApiCalls.updateLeaveApprovalAsTL(id, tl_data, false);
            if (res.success) {
               handleCloseDrawer();
            }
        }
        setApprovalDialog(false)
        setLeavePayload({})
        getLeaveApproval();
    }
    const [leaveData, setLeaveData] = useState(
			
			{
        columns: [

            {
                Header: "Employee",
                accessor: "employee",
                Cell: ({ row }) => (
                    <div style={{ display: "flex", alignItems: "center" }} onClick={() => handleOpenDrawer(row)}>
                        <Avatar src={row.original.profilePhoto} alt="Profile Photo" sx={{ width: 30, height: 30 }} />
                        {/* <MDTypography style={{ marginLeft: "0.5rem" }}>
                            {row.original?.leave?.employee?.user?.firstname}
                        </MDTypography>
                        <MDTypography style={{ marginLeft: "0.2rem" }}>
                            {row.original?.leave?.employee?.user?.lastname}
                        </MDTypography> */}
                        <MDTypography variant="h6" marginLeft='4px' fontSize='14px' fontWeight='600px'>
                            {row.original?.leave?.employee?.user?.firstname} {row.original?.leave?.employee?.user?.lastname}
                        </MDTypography>
                    </div>
                ),
            },
            {
                Header: "Apply Date",
                accessor: "apply_date",
                Cell: ({ row }) =>
                    // moment(row.original.leave.create_at).format("YYYY-MM-DD"),
                    dayjs(row.original.leave.created_at).format("YYYY-MM-DD"),
            },
            {
                Header: "Start Date",
                accessor: "start_date",
                Cell: ({ row }) => row.original.leave.start_date,
            },
            {
                Header: "End Date",
                accessor: "end_date",
                Cell: ({ row }) => row.original.leave.end_date,
            },
            {
                Header: "Number of Hours",
                accessor: "number_of_hours",
                Cell: ({ row }) => row.original.leave.number_of_hours,
            },
            {
                Header: "Status",
                accessor: "status",
							Cell: ({ row }) => {

								const statusColors = {
									pending: { background: "#FB8C00", text: "#FFF" },
									approved: { background: "#4CAF50", text: "#FFF" },
									rejected: { background: "#F44336", text: "#FFF" },
								};

								// Extract color settings based on status
								const status = row.original.leave.status;
								const chipColors = statusColors[status] ?? { background: "#E0E0E0", text: "#000" }; 

									return (
										<Chip
											label={row.original.leave.status.toUpperCase()}
											sx={{
												mt: 1,
												backgroundColor: statusColors[status].background || "#E0E0E0", // Set background color
												color: statusColors[status].text || "#000", // Set text color
												fontWeight: 'small'
											}}
										/>
									)
							}
            },
            {
                Header: "Action",
                accessor: "action",
                Cell: ({ row }) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <Tooltip title="Action">
                            <IconButton
                                aria-label="Action"
                                size="small"
                                onClick={() => {
                                    handleDeleteLeave(row?.original);
                                }}
                            >
                               <Cancel/>
                            </IconButton>
                        </Tooltip>
                    </div>
                ),
            },
        ],
        rows: [],
    });

    const handleOpenDrawer = (row) => {
        setSelectedRow(row.original);
        getLeaveBalance(row.original.leave.employee.id)
        setDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setDrawerOpen(false);
        setSelectedRow(null);
    };

    const renderDrawerForSalaryDetails = () => {

        const statusColors = {
            pending: { background: "#FB8C00", text: "#FFF" }, 
            approved: { background: "#4CAF50", text: "#FFF" }, 
            rejected: { background: "#F44336", text: "#FFF" }, 
        };

        // Extract color settings based on status
        const status = selectedRow.leave.status.toLowerCase();
        const chipColors = statusColors[status] || { background: "#E0E0E0", text: "#000" }; // Default gray


        const takenTransactions = selectedRow?.leave?.transactions
            .filter((txn) => txn.transaction_type === "taken")
            .sort((a, b) => new Date(b.transaction_date) - new Date(a.transaction_date))
            .slice(0, 3);
        return (
            <Drawer anchor="right" open={drawerOpen} onClose={handleCloseDrawer}
                PaperProps={{
                    sx: { width: 350, margin: "0 !important", height: '100%', borderRadius: '0' },

                }}
            >
                <Box sx={{
                    p: 2,
                    height: "100%",
                    overflow: "auto",
                    "&::-webkit-scrollbar": { display: "none" },
                    "-ms-overflow-style": "none",
                    "scrollbar-width": "none"
                }}>
                    {/* Header with Close Button */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                        <MDTypography variant="h6" fontWeight="bold">
                            Employee Leave Details
                        </MDTypography>
                        <IconButton onClick={handleCloseDrawer}>
                            <Close />
                        </IconButton>
                    </Box>

                    {/* Employee Profile Section */}
                    {selectedRow && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                            <Avatar alt="Profile Photo" sx={{ width: 70, height: 70 }}>
                                <img
                                    src={`${base_url}${selectedRow?.leave?.employee?.img}`}
                                    style={{
                                        width: "70px",
                                        height: "70px",
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                    }}
                                />
                            </Avatar>
                            <Box>
                                <MDTypography variant="h6" fontWeight="bold">
                                    {selectedRow?.leave?.employee?.user?.firstname} {selectedRow?.leave?.employee?.user?.lastname}
                                </MDTypography>
                                <Chip
                                    label={selectedRow.leave.status.toUpperCase()}
                                    sx={{
                                        mt: 1,
                                        backgroundColor: chipColors.background, // Set background color
                                        color: chipColors.text, // Set text color
                                        fontWeight : 'bold'
                                    }}
                                />
                            </Box>
                        </Box>
                    )}

                    <Divider sx={{ my: 2 }} />

                    {selectedRow && <Box>
                        <MDTypography variant="h6">Available Balances</MDTypography>
                        <Box display='flex' justifyContent='space-between'>
                            <Box display='flex' flexDirection='column' alignItems='center'>
                            <MDTypography variant="h6" fontSize='16px'>{leaveBalance?.casual_leave || 0}</MDTypography>
                            <MDTypography variant='body2' color='text.secondary'>Casual Leaves</MDTypography>
                            </Box>
                            <Box display='flex' flexDirection='column' alignItems='center'>
                            <MDTypography variant="h6" fontSize='16px'>{leaveBalance?.un_paid || 0}</MDTypography>
                            <MDTypography variant='body2' color='text.secondary'>Unpaid Leaves</MDTypography>
                            </Box>
                        </Box>
                    </Box>
                    }

                    <Divider sx={{ my: 2 }} />

                    {selectedRow && (

                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Event fontSize="12px" />
                                <Box>
                                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>Start Date</MDTypography>
                                    <MDTypography variant="body2" fontSize='12px'>{selectedRow.leave.start_date}</MDTypography>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Event fontSize="12px" />
                                <Box>
                                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>End Date</MDTypography>
                                    <MDTypography variant="body2" fontSize='12px'>{selectedRow.leave.end_date}</MDTypography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <AccessTime fontSize="12px" />
                                <Box>
                                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>Total Hours</MDTypography>
                                    <MDTypography variant="body2" fontSize='12px'>{selectedRow.leave.number_of_hours}</MDTypography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <DateRange fontSize="12px" />
                                <Box>
                                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>Applied On</MDTypography>
                                    <MDTypography variant="body2" fontSize='12px'>{dayjs(selectedRow.leave.created_at).format("YYYY-MM-DD")}</MDTypography>
                                </Box>
                            </Grid>
                        </Grid>
                    )}

                    <Box sx={{ marginTop: '14px' }}>
                        <MDTypography variant="h6" fontSize='16px' fontWeight='600px'>Description</MDTypography>
                        <MDTypography variant="body1" fontSize='14px' whiteSpace='pre-wrap' fontWeight='400px'>{selectedRow?.leave?.reason}</MDTypography>
                    </Box>

                    <Accordion sx={{ marginTop: "14px" }}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <MDTypography variant="h6" fontSize="16px" fontWeight="600">
                                Leaves Transactions
                            </MDTypography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {takenTransactions?.length > 0 ? (
                                takenTransactions?.map((txn) => (
                                    <Box key={txn.id} sx={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                        <MDTypography variant="body1" fontSize="14px" fontWeight="600">
                                            {moment(txn.transaction_date).format("YYYY-MM-DD")}
                                        </MDTypography>
                                        <Grid container spacing={2} sx={{ marginTop: "4px" }}>
                                            <Grid item xs={4}>
                                                <MDTypography variant="body2" fontSize="12px" color="gray">
                                                    Old Balance
                                                </MDTypography>
                                                <MDTypography variant="body1" fontSize="14px">{txn.old_balance}</MDTypography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <MDTypography variant="body2" fontSize="12px" color="gray">
                                                    New Balance
                                                </MDTypography>
                                                <MDTypography variant="body1" fontSize="14px">{txn.new_balance}</MDTypography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <MDTypography variant="body2" fontSize="12px" color="gray">
                                                    Leaves Taken
                                                </MDTypography>
                                                <MDTypography variant="body1" fontSize="14px">{txn.old_balance - txn.new_balance}</MDTypography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))
                            ) : (
                                <MDTypography variant="body1" fontSize="14px">
                                    No transactions available.
                                </MDTypography>
                            )}
                        </AccordionDetails>
                    </Accordion>

                    <Divider sx={{ my: 2 }} />
                    <Box sx={{ marginTop: '14px', display: 'flex', justifyContent: 'space-between' }}>
                        <Box>
                            <MDTypography variant="h6" fontSize='14px' fontWeight='600px'>Team Lead</MDTypography>
                            <MDTypography variant="body1" fontSize='14px' fontWeight='400px'>{selectedRow?.leave?.employee?.manager_name}</MDTypography>
                        </Box>
                        <Box display='flex' flexDirection='column' alignItems='flex-end'>
                            <Box display='flex' >
                                <MDTypography variant="h6" fontSize='14px' fontWeight='600px'>Status </MDTypography>
                                <ArrowDropDown onClick={toggleTLUpdateCard} />
                            </Box>
                            {/* <MDTypography variant="body1" fontSize='14px' fontWeight='400px'>{selectedRow?.tl_decision ? selectedRow?.tl_decision === 'rejected' ? "Rejected" : "Approved" : 'Pending'}</MDTypography> */}
                            <MDButton
                                size="small"
                                variant='contained'
                                color={
                                    selectedRow?.tl_decision === 'rejected'
                                        ? 'error' :
                                        selectedRow?.tl_decision === 'approved'
                                            ? 'success' : 'warning'
                                }
                                onClick={toggleTLUpdateCard}
                                disabled={user.employee_id !== selectedRow.tl}
                            >
                                {selectedRow?.tl_decision ? (selectedRow?.tl_decision === 'rejected' ? "Rejected" : "Approved") : 'Pending'}
                            </MDButton>
                        </Box>
                    </Box>
                    {showTLUpdateCard && <Card sx={{ marginTop: '14px', padding: '14px' }}>
                        {user.employee_id === selectedRow.tl ? <Box><MDTypography variant="h6" fontSize='14px' fontWeight='600px' sx={{ marginBottom: '8px' }}>Update Status</MDTypography>
                            <TextField placeholder="Description" fullWidth onChange={(e)=>setDescription(e.target.value)}/>
                            <Box display='flex' justifyContent='flex-end' sx={{ gap: '6px', marginTop: '16px' }}>
                                <MDButton
                                    size='small'
                                    
                                    onClick={() => {
                                        approveLeave(
                                            selectedRow.id,
                                            "approved",
                                            selectedRow.manager,
                                            selectedRow.tl
                                        );
                                    }}
                                    variant='contained'
                                    color='success'
                                    disabled={!description}
                                >
                                    Accept
                                </MDButton>
                                <MDButton
                                    size='small'
                                    onClick={() => {
                                        approveLeave(
                                            selectedRow.id,
                                            "rejected",
                                            selectedRow.manager,
                                            selectedRow.tl
                                        );
                                    }}
                                    variant='contained'
                                    color='error'
                                    disabled={!description}
                                >
                                    Reject
                                </MDButton>
                            </Box>
                        </Box> : <MDTypography variant="h6" fontSize='14px' fontWeight='400px'>You are not permitted to perform this action.</MDTypography>}
                    </Card>}

                    <Box sx={{ marginTop: '14px', display: 'flex', justifyContent: 'space-between' }}>
                        <Box>
                            <MDTypography variant="h6" fontSize='14px' fontWeight='600px'>HR Manager</MDTypography>
                            <MDTypography variant="body1" fontSize='14px' fontWeight='400px'>{selectedRow?.leave?.employee?.hr_manager_name}</MDTypography>
                        </Box>

                        <Box display='flex' flexDirection='column' alignItems='flex-end'>
                            <Box display='flex'>
                                <MDTypography variant="h6" fontSize='14px' fontWeight='600px'>Status </MDTypography>
                                <ArrowDropDown onClick={toggleHRUpdateCard} />
                            </Box>
                            <MDButton
                                size="small"
                                variant='contained'
                                color={
                                    selectedRow?.manager_decision === 'rejected'
                                        ? 'error' :
                                        selectedRow?.manager_decision === 'approved'
                                            ? 'success' : 'warning'
                                }
                                onClick={toggleHRUpdateCard}
                                disabled={user.employee_id != selectedRow.manager}
                            >
                                {selectedRow?.manager_decision ? (selectedRow?.manager_decision === 'rejected' ? "Rejected" : "Approved") : 'Pending'}
                            </MDButton>
                        </Box>

                    </Box>
                    {showHRUpdateCard &&
                        <Card sx={{ marginTop: '14px', padding: '14px' }}>
                            {user.employee_id == selectedRow.manager ? 
                            <Box><MDTypography variant="h6" fontSize='14px' fontWeight='600px' sx={{ marginBottom: '8px' }}>Update Status</MDTypography>
                                <TextField placeholder="Description" fullWidth onChange={(e) => setDescription(e.target.value)}/>
                                <Box display='flex' justifyContent='flex-end' sx={{ gap: '6px', marginTop: '16px' }}>
                                    <MDButton
                                        size='small'
                                        onClick={() => {
                                            approveLeave(
                                                selectedRow.id,
                                                "approved",
                                                selectedRow.manager,
                                                selectedRow.tl
                                            );
                                        }}
                                        variant='contained'
                                        color='success'
                                        // disabled={!description}
                                    >
                                        Accept
                                    </MDButton>
                                    <MDButton
                                        size='small'
                                        onClick={() => {
                                            approveLeave(
                                                selectedRow.id,
                                                "rejected",
                                                selectedRow.manager,
                                                selectedRow.tl
                                            );
                                        }}
                                        variant='contained'
                                        color='error'
                                        // disabled={!description}
                                    >
                                        Reject
                                    </MDButton>
                                </Box></Box> 
                                 :
                                <MDTypography variant="h6" fontSize='14px' fontWeight='400px'>You are not permitted to perform this action.</MDTypography>
                            } 
                        </Card>}
                </Box>
            </Drawer>
        )
    }
    return (
        // <DashboardLayout>
        //   <DashboardNavbar />
        <> <MDBox>
            <Card>
					<MDBox sx={{ display: "flex", alignItems: "center", gap: 2, padding:3}}>
						<MDBox
							sx={{
								width: 48,
								height: 48,
								borderRadius: "16px",
								display: "grid",
								placeItems: "center",
								background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
								color: colors.white.main,
							}}
						>
							<Approval />
						</MDBox>
						<MDBox sx={{ display: "flex", flexDirection: "column" }}>
							<MDTypography
								variant="h4"
								//sx={{ color: colors.dark.main, letterSpacing: "-0.03em" }}
							>
								Leaves Management
							</MDTypography>
							<MDTypography variant="body2" color="text" sx={{ mt: 0.5 }}>
								Track the leaves requests from your team members
							</MDTypography>
						</MDBox>
					</MDBox>
					<MDBox>
                {leaveData.rows.length > 0 ? (
                <DataTable table={leaveData} entriesPerPage={false} />
            ) : (
                <MDBox textAlign="center" p={3}>
                    <MDTypography variant="h6" color="textSecondary">
                        No records available
                    </MDTypography>
                </MDBox>
            )}
                </MDBox>
            </Card>
        </MDBox>

            <Dialog
                open={approvalDialog}
                onClose={() => {
                    setApprovalDialog(false);
                }}
            >
                <DialogTitle>Leave Approval Action</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        placeholder="Add Remark here"
                        onChange={(event) => {
                            setRemark(event.target.value);
                        }}
                        InputProps={{
                            inputComponent: TextareaAutosize,
                            rows: 3,
                        }}
                    ></TextField>
                </DialogContent>
                <DialogActions>
                    <MDButton
                        color="info"
                        onClick={() => {
                            approveLeave(
                                leavePayload.id,
                                "approved",
                                leavePayload.manager,
                                leavePayload.tl
                            );
                        }}
                    >
                        Approve
                    </MDButton>
                    <MDButton
                        color="red"
                        onClick={() => {
                            approveLeave(
                                leavePayload.id,
                                "rejected",
                                leavePayload.manager,
                                leavePayload.tl
                            );
                        }}
                    >
                        Reject
                    </MDButton>
                    <MDButton
                        onClick={() => {
                            setApprovalDialog(false);
                        }}
                    >
                        Cancel
                    </MDButton>
                </DialogActions>
            </Dialog>

            {drawerOpen && renderDrawerForSalaryDetails()}
        </>

        // </DashboardLayout>
    );
}
export default ManageLeaves;
